import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CollectionsList.styled';

interface CollectionListItemProps {
  image: string;
  title: string;
  count?: number;
  onClick?: () => void;
  isSelected?: boolean;
  isSelectable?: boolean;
}

export const CollectionListItem = ({
  image,
  title,
  count,
  isSelected,
  isSelectable = true,
  onClick,
}: CollectionListItemProps) => {
  const { t } = useTranslation();

  return (
    <S.Item
      onClick={onClick}
      $isSelected={isSelected}
      $isSelectable={isSelectable}
    >
      <S.Image $image={image} />
      <S.ItemInfo>
        <S.ItemTitle>{title}</S.ItemTitle>
        {count && (
          <S.ItemCount>
            {t('bookmark_collections.item_ad_count', { count })}
          </S.ItemCount>
        )}
      </S.ItemInfo>

      {isSelectable && <S.Checkbox $isChecked={isSelected} />}
    </S.Item>
  );
};
